// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuotedTextTitle__container-e7b712 {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--chat-bubble-primary);
  display: inline-flex;
  gap: 4px;
}

.QuotedTextTitle__profile-icon-d92a33 {
  fill: currentColor;
  flex-shrink: 0;
  flex-grow: 0;
  vertical-align: baseline;
}

.QuotedTextTitle__text-d32ebb,
.QuotedTextTitle__sender-d5bb3d {
  flex: 1 0 50%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.QuotedTextTitle__sender-d5bb3d {
  display: flex;
  gap: 2px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/QuotedText/QuotedTextTitle/QuotedTextTitle.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,0CAAA;EACA,iCAAA;EACA,oBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF","sourcesContent":[".container {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--chat-bubble-primary);\n  display: inline-flex;\n  gap: 4px;\n}\n\n.profile-icon {\n  fill: currentColor;\n  flex-shrink: 0;\n  flex-grow: 0;\n  vertical-align: baseline;\n}\n\n.text,\n.sender {\n  flex: 1 0 50%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sender {\n  display: flex;\n  gap: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuotedTextTitle__container-e7b712`,
	"profile-icon": `QuotedTextTitle__profile-icon-d92a33`,
	"profileIcon": `QuotedTextTitle__profile-icon-d92a33`,
	"text": `QuotedTextTitle__text-d32ebb`,
	"sender": `QuotedTextTitle__sender-d5bb3d`
};
module.exports = ___CSS_LOADER_EXPORT___;
